import type { BuffDefinition, StatusEffect } from "../types";

const BUFF_ICON_BASE = "/assets/buffs";

export function getBuffIconPath(icon: string): string {
  return `${BUFF_ICON_BASE}/${icon}.svg`;
}

export function resolveEffectMeta(
  effect: StatusEffect,
  definitions: Record<string, BuffDefinition> | null | undefined,
): { name: string; description: string; icon: string } {
  const def = definitions?.[effect.id];
  const tierNote =
    effect.tier > 1 && effect.persistent ? ` (tier ${effect.tier})` : "";
  const stacksNote = effect.stacks > 1 ? ` x${effect.stacks}` : "";
  const turnsNote =
    !effect.persistent && effect.turns_left > 0
      ? ` — ${effect.turns_left} turn(s) left`
      : "";

  return {
    name: (def?.name ?? effect.id) + tierNote + stacksNote,
    description: (def?.description ?? "") + turnsNote,
    icon: def?.icon ?? effect.id,
  };
}

export function isDebuff(effect: StatusEffect): boolean {
  return effect.kind === "debuff";
}
